import React from 'react'
import Template from '../../components/layout/Public'
import Form from './Form'
import SSOButtons from './SSOButtons'
import { Link } from 'react-router-dom'

const Login = () => (
  <Template title='Sign in to Maestro'>
    <SSOButtons />
    <Form />
    <Link to='/password-reset' className='text-right-login'>
      Forgot your password?
    </Link>
  </Template>
);


export default Login;
